import React from 'react';
import { useNavigate } from 'react-router';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CommonButton from '../../component/button/Button';

const Cancel = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-column items-center justify-center h-screen">
      <ErrorOutlineIcon sx={{ fontSize: 80, color: 'red' }} />
      <h1>Payment Cancelled</h1>
      <p>No charges were made. You can try again whenever you are ready.</p>
      <CommonButton text="Back to Billing" onClick={() => navigate('/billing')} />
    </div>
  );
};
export default Cancel;